// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14">
            <path
                fill="currentColor"
                d="M11.2490197,1.75 L9.81682835,1.75 L9.81682835,0.65625 C9.81682835,0.293945313 9.52271838,0 9.18483372,0 C8.84694907,0 8.5035931,0.293945313 8.5035931,0.65625 L8.5035931,1.75 L4.58506984,1.75 L4.58506984,0.65625 C4.58506984,0.293945312 4.2923279,0 3.92845222,0 C3.56457653,0 3.27183459,0.293945312 3.27183459,0.65625 L3.27183459,1.75 L1.75098034,1.75 C0.783837125,1.75 0,2.53339827 0,3.5 L0,12.25 C0,13.2166017 0.783837125,14 1.75098034,14 L11.2490197,14 C12.2161629,14 13,13.2166017 13,12.25 L13,3.5 C13,2.53339827 12.2147944,1.75 11.2490197,1.75 Z M10.505882,12.6875 L1.75098034,12.6875 C1.50961847,12.6875 1.31323484,12.4912814 1.31323484,12.25 L1.31323484,5.25 L11.7260483,5.25 L11.7260483,12.25 C11.7260483,12.4906247 11.5290627,12.6875 11.2883032,12.6875 L10.505882,12.6875 Z"
            />
        </svg>
    );
};

export default React.memo(Calendar);
